import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { concatMap, map, retryWhen } from 'rxjs/operators';
import { EnvironmentService } from 'src/app/environment.service';
import { IRoadSalesMain, ISitecoreRootObject } from '../../models/sitecore-models';
import { AAConstant, AppError } from '../../models/constants';

@Injectable({
  providedIn: 'root'
})
export class SitecoreService {
  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getHeadlessContent(): Observable<IRoadSalesMain> {
    const sitecoreParams = {
      item: this.envService.routeModel.itemId,
      sc_lang: 'en',
      sc_apikey: `{${this.envService.routeModel.apiKey}}`
    };
    const sitecoreUrl = this.envService.routeModel.sitecoreXMheadlessUrl

    return this.http.get<ISitecoreRootObject>(sitecoreUrl, { params: sitecoreParams }).pipe(
      retryWhen(concatMap((err, index) => (index < 3 ? timer(2000) : throwError(err)))),
      map((response) => {
        const roadSalesMainObj = response?.sitecore?.route?.placeholders?.[AAConstant.ROAD_SALES_MAIN];
        if (roadSalesMainObj?.length) {
          return roadSalesMainObj.find((el) => el.componentName === AAConstant.PROMO_BANNER_COMPONENT_NAME);
        } else {
          console.error(AppError.INVALID_SITECORE_RESPONSE);
        }
      })
    );
  }
}
